// extracted by mini-css-extract-plugin
module.exports = {"back":"FloatMessage_back__fpVtS","root":"FloatMessage_root__p3SyO"};